// @ts-check
import React from 'react';
import * as authClient from '../utils/authClient';
import { useAsync } from 'react-async';

const AuthContext = React.createContext(null);

function AuthProvider(props) {
  const [firstAttemptFinished, setFirstAttemptFinished] = React.useState(false);

  const { data, error, isRejected, isPending, isSettled, reload } = useAsync({
    promiseFn: authClient.getUser,
  });

  React.useLayoutEffect(() => {
    if (isSettled) {
      setFirstAttemptFinished(true);
    }
  }, [isSettled]);

  if (!firstAttemptFinished) {
    if (isPending) {
      return null; // don't show anything while validating the current token
    }
    if (isRejected) {
      return (
        <div>
          <p>A problem has occurred. Try refreshing the app.</p>
          <pre>{error.message}</pre>
        </div>
      );
    }
  }

  const login = (form) => authClient.login(form).then(reload);
  const logout = () =>
    authClient.logout().then((logoutRedirect) => {
      if (logoutRedirect) {
        window.location.href =
          process.env.REACT_APP_WEBSITE_URL + logoutRedirect;
      } else {
        reload();
      }
    });

  const newUserName = new URLSearchParams(window.location.search).get(
    'userName'
  );

  let finalData = data || null;
  if (data && (data.LoginName.startsWith('PublicLogin') || !data.DisplayName))
    finalData = null;
  else if (newUserName && data && newUserName !== data.LoginName)
    finalData = null;

  return (
    <AuthContext.Provider
      value={{
        data: finalData,
        login,
        logout,
      }}
      {...props}
    />
  );
}

function useAuth() {
  const context = React.useContext(AuthContext);
  if (context === undefined)
    throw new Error('useAuth must be used within a AuthProvider');

  return context;
}

export { AuthProvider, useAuth };
